import * as React from 'react';
import * as flowerBlue from '../../../lotties/daily_lesson/flower_blue.json';
import * as flowerGreen from '../../../lotties/daily_lesson/flower_green.json';
import * as flowerPink from '../../../lotties/daily_lesson/flower_pink.json';
import * as flowerYellow from '../../../lotties/daily_lesson/flower_yellow.json';
import { DailyLessonLottieIcon } from './daily_lesson_lottie_icon';
const ANIMATION_BY_COLOR = {
    green: flowerGreen,
    pink: flowerPink,
    yellow: flowerYellow,
    blue: flowerBlue,
};
export const DailyLessonFlowerLottieIcon = ({ volumeColor, classObject }) => {
    return React.createElement(DailyLessonLottieIcon, { animationData: ANIMATION_BY_COLOR[volumeColor], classObject: classObject });
};
